import alisha from "./alisha.pdf";
const Alisha = () => {
    return (
        <div className="w-screen h-screen">
            <object
                data={alisha}
                type="application/pdf"
                className="w-full h-full"
            >
                <p>
                    PDF cannot be displayed.
                    <a href={alisha}>Download PDF</a>
                </p>
            </object>
        </div>
    )
}

export default Alisha;